import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: "calling-card"
};
var _hoisted_2 = {
  class: "calling_top"
};
var _hoisted_3 = {
  class: "top_name"
};
var _hoisted_4 = {
  class: "school_name"
};
var _hoisted_5 = {
  class: "calling_center"
};
var _hoisted_6 = {
  class: "calling_group"
};
var _hoisted_7 = {
  class: "calling_dynamic"
};
var _hoisted_8 = {
  key: 0,
  class: "calling_homepage"
};
var _hoisted_9 = ["src"];
var _hoisted_10 = {
  class: "calling_bottom"
};
import { ref, watch } from 'vue';
import { personalCard } from '@/api/personalHomepage';
import { getStore } from '@/util/store';
export default {
  __name: 'calling',
  props: {
    item: {
      type: String,
      default: ''
    },
    cardInfo: {
      type: Number,
      default: 0
    },
    index: {
      type: Number,
      default: 0
    },
    spaceInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  emits: ['changeToHome'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var userInfo = getStore({
      name: 'userInfo'
    });
    var emit = __emit;
    var props = __props;
    var list = ref({});
    var getCardInfo = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(id) {
        var _yield$personalCard, data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return personalCard(id);
            case 1:
              _yield$personalCard = _context.v;
              data = _yield$personalCard.data;
              list.value = data.data;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function getCardInfo(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    watch(function () {
      return props;
    }, function (val) {
      var item = val.item,
        cardInfo = val.cardInfo,
        index = val.index;
      if (cardInfo === index) {
        getCardInfo(item);
      }
    }, {
      deep: true,
      immediate: true
    });

    // 去他的主页
    var goToHome = function goToHome(val) {
      emit('changeToHome', val.userId, val.userType);
    };
    var hasAuth = function hasAuth(school) {
      return (school === null || school === void 0 ? void 0 : school.filter(function (x) {
        return userInfo.schools.includes(x.schoolName);
      }).length) > 0;
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createTextVNode(_toDisplayString(list.value.name) + " ", 1), _createElementVNode("span", {
        class: _normalizeClass(list.value.userType === '0' ? 'student' : 'teacher')
      }, _toDisplayString(list.value.userType === '0' ? '学生' : '教师'), 3)]), _createElementVNode("div", _hoisted_4, _toDisplayString(list.value.institutionName), 1)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, [_createTextVNode(_toDisplayString(list.value.addedGroupNum) + " ", 1), _cache[1] || (_cache[1] = _createElementVNode("div", null, "加入群组", -1))]), _createElementVNode("span", _hoisted_7, [_createTextVNode(_toDisplayString(list.value.publishDynamicNum) + " ", 1), _cache[2] || (_cache[2] = _createElementVNode("div", null, "群组动态", -1))])]), list.value.userType !== '2' && hasAuth(list.value.schoolDetails) ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_cache[4] || (_cache[4] = _createTextVNode(" 个人主页 ", -1)), _createElementVNode("span", {
        class: "calling_link",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return goToHome(list.value);
        })
      }, [_cache[3] || (_cache[3] = _createElementVNode("span", null, "去他的主页逛逛", -1)), _createElementVNode("img", {
        src: require('@/assets/home/chevron-right.svg'),
        alt: ""
      }, null, 8, _hoisted_9)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_10, [_cache[5] || (_cache[5] = _createElementVNode("span", null, "个人简介", -1)), _createElementVNode("span", null, _toDisplayString(list.value.remark || '这个人很懒，什么都没留下~'), 1)])]);
    };
  }
};